import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ResizeObserverDirective } from './directives/resize-observer.directive';

@NgModule({
  imports: [CommonModule, ResizeObserverDirective],
  exports: [ResizeObserverDirective],
})
export class ResizeObserverModule {}
